import React, { useState } from 'react';
import { Input, Button, Form } from 'antd';
import axios from 'axios';
import { POST } from '../../utils/apis';
import { errorMessage, successMessage } from '../../utils/helpers';

const SubscriptionForm = (props) => {
    const { selectedLanguage } = props
    const [form] = Form.useForm()
    const [loading, setLoading] = useState(false)

    const onFinish = (values) => {
        setLoading(true)
        values.designName = 'clinic-design-5'
        axios.post(POST?.CREATE_CONTACT_FORM, values)
            .then((res) => {
                const { data } = res
                setLoading(false)
                form.resetFields()
                if (data?.success) {
                    successMessage(data?.message)
                } else {
                    errorMessage(data?.message)
                }
            })
            .catch((e) => {
                setLoading(false)
                form.resetFields()
                errorMessage(e?.message)
            })
    }

    return (
        <>
            <div className="d2-form-main d5-form-main">
                <Form
                    name='form'
                    form={form}
                    onFinish={onFinish}
                    layout={'vertical'}
                    requiredMark={true}
                >
                    <Form.Item
                        className='d2-subs-form-item'
                        name="name"
                    >
                        <Input className='d2-subs-form-input d5-subs-form-input' placeholder={selectedLanguage?.input_name_placeholder} />
                    </Form.Item>
                    <Form.Item
                        className='d2-subs-form-item'
                        name="postCode"
                        rules={[
                            {
                                required: false
                            },
                            {
                                validator: (_, value) => {
                                    const regex = /^\d{4}\s[A-Z]{2}$/;
                                    if (!value || regex.test(value)) {
                                        return Promise.resolve();
                                    }
                                    return Promise.reject(new Error(`${selectedLanguage?.PleaseInput_correct_format}: (1234 AB)`));
                                },
                            },
                        ]}
                        normalize={(value) => {
                            if (!value) return value;
                            value = value.toUpperCase();
                            value = value.replace(/\s/g, '');
                            if (value.length > 4) {
                                value = value.slice(0, 4) + ' ' + value.slice(4);
                            }
                            return value;
                        }}
                    >
                        <Input className='d2-subs-form-input d5-subs-form-input' placeholder={selectedLanguage?.txt_postal_code} />
                    </Form.Item>
                    <Form.Item
                        className='d2-subs-form-item'
                        name="email"
                        rules={[
                            {
                                required: true,
                                message: selectedLanguage?.txt_please_enter_your_email_message,
                            },
                            {
                                type: 'email',
                                message: selectedLanguage?.EmailIsNotValid,
                            },
                        ]}
                    >
                        <Input className='d2-subs-form-input d5-subs-form-input' type="email" placeholder={selectedLanguage?.input_email_placeholder} />
                    </Form.Item>
                    <Form.Item className='d2-subs-form-item'>
                        <Button
                            type='primary'
                            className='d2-subs-form-btn d5-subs-form-btn'
                            htmlType='submit'
                            loading={loading}
                        >
                            {selectedLanguage?.txt_send}
                        </Button>
                    </Form.Item>
                </Form>
            </div>
        </>
    )
}
export default SubscriptionForm